import React, { useEffect, useState } from "react";
import img from "../../assets/images/azlogomessage.jpeg";

import { getSponsorIMG } from "../../services/HomeServices";
import { toast } from "react-toastify";
import { motion, useAnimation } from "framer-motion";

const AdSlider = () => {
  const [data, setdata] = useState([]);
  const [isHover, setisHover] = useState(false);

  useEffect(() => {
    const controller = new AbortController(); // 1. Create controller

    const timeout = setTimeout(() => {
      getSponsorImage(controller?.signal);
    }, 700);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, []);

  const getSponsorImage = async (signal) => {
    await getSponsorIMG(signal)
      .then((response) => {
        setdata(response?.data?.data);
      })
      .catch((error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  return (
    <div className="container-fluid bg_222">
      <div className="marquee-wrapper">
        <div
          className="marquee-block"
          style={{ width: `${data?.length * 270}px` }}
        >
          <div
            className={`marquee-inner ${"to-left"} `}
            style={{
              animationPlayState: isHover ? "paused " : "running",
            }}
          >
            {" "}
            <span>
              {data?.map((x) => (
                <motion.div
                  onMouseEnter={() => setisHover(true)}
                  onMouseLeave={() => setisHover(false)}
                  whileHover={{ scale: 1.2 }} // Scale up the image on hover
                  transition={{ type: "spring", stiffness: 300 }} // Smooth transition with spring effect
                  className="ad_card"
                >
                  <a href={x?.url} target="blank">
                    <img
                      src={x?.image}
                      alt="ad"
                      height={"114px"}
                      width={"250px"}
                    />{" "}
                  </a>
                </motion.div>
              ))}
            </span>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdSlider;
